import {isMobile} from '#core/utils/context-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {generateSwitch} from '#core/application/modules/tiles/switch/index.js';
import {generatePopover} from '#core/application/modules/tiles/popover/index.js';
import {generateDotNotification} from '#core/application/modules/tiles/dot-notification/index.js';

export function breadcrumbsFactory(PALETTE) {
    return !isMobile() ? breadcrumbsDesktopFactory(PALETTE) : breadcrumbsMobileFactory(PALETTE);
}

function breadcrumbsDesktopFactory(PALETTE) {
    return {
        // I hope they will remove this component in the future to stop confusing us with namings
        Breadcrumbs: {
            breadcrumb: {
                style: {
                    base: PALETTE.BREADCRUMBS_TEXT,
                    disabled: PALETTE.BREADCRUMBS_TEXT,
                    hover: PALETTE.BREADCRUMBS_TEXT,
                },
            },
            separator: {
                style: {
                    fill: PALETTE.BREADCRUMBS_SEPARATOR_COLOR,
                },
            },
        },
        ...breadcrumbsGenericFactory(PALETTE),
    };
}

function breadcrumbsMobileFactory(PALETTE) {
    return {
        // yes, it looks horrible, but I have no other choice to place it here because I need to know based-on value for these icons
        // and it's possible to get it only inside this factory. Mojito placed these two buttons in absolutely positioned container
        // and just change its position to make it look like a part of Breadcrumbs but physically these buttons are still a part
        // of BetHistoryDetails component
        ...(!ApplicationConfig.isEmbedded
            ? {
                  BetHistoryView: {
                      betHistoryDetailsController: {
                          betHistoryDetails: {
                              shareBet: {
                                  shareButton: {
                                      buttonIcon: {
                                          style: {
                                              fill: PALETTE.MOBILE_BREADCRUMBS_SHARE_BET_ICON_COLOR,
                                          },
                                      },
                                  },
                              },
                              downloadBetPdfButton: {
                                  icon: {
                                      style: {
                                          fill: PALETTE.MOBILE_BREADCRUMBS_DOWNLOAD_PDF_ICON_COLOR,
                                      },
                                  },
                              },
                          },
                      },
                  },
              }
            : {}),
        ...breadcrumbsGenericFactory({
            ...PALETTE,
            BREADCRUMBS_BG: PALETTE.MOBILE_BREADCRUMBS_BG,
            BREADCRUMBS_TEXT: PALETTE.MOBILE_BREADCRUMBS_TEXT,
            BREADCRUMBS_ICON_COLOR: PALETTE.MOBILE_BREADCRUMBS_ICON_COLOR,
            BREADCRUMBS_BACK_BUTTON_ICON_COLOR: PALETTE.MOBILE_BREADCRUMBS_BACK_BUTTON_ICON_COLOR,
            BREADCRUMBS_QUICK_NAVIGATION_CATEGORY_TEXT: PALETTE.MOBILE_BREADCRUMBS_QUICK_NAVIGATION_CATEGORY_TEXT,
            BREADCRUMBS_QUICK_NAVIGATION_TOURNAMENT_TEXT: PALETTE.MOBILE_BREADCRUMBS_QUICK_NAVIGATION_TOURNAMENT_TEXT,
            BREADCRUMBS_QUICK_NAVIGATION_ICON_COLOR: PALETTE.MOBILE_BREADCRUMBS_QUICK_NAVIGATION_ICON_COLOR,
            BREADCRUMBS_SUBSCRIBER_BELL_ICON_COLOR: PALETTE.MOBILE_BREADCRUMBS_SUBSCRIBER_BELL_ICON_COLOR,
            BREADCRUMBS_SUBSCRIBER_DOT_NOTIFICATION: PALETTE.MOBILE_BREADCRUMBS_SUBSCRIBER_DOT_NOTIFICATION,
        }),
    };
}

function breadcrumbsGenericFactory(PALETTE) {
    return {
        PageHeader: {
            headerContainer: {
                style: {
                    padding: 0,
                    flexGrow: 1,
                    ...resolveBackground(PALETTE.BREADCRUMBS_BG),
                },
            },
            label: {
                style: {
                    ...PALETTE.BREADCRUMBS_TEXT,
                },
            },
            icon: {
                style: {
                    minHeight: 16,
                    minWidth: 16, //fix margin which added by mojito
                    flexBasis: 0,
                    margin: '0 8px',
                    fill: PALETTE.BREADCRUMBS_ICON_COLOR,
                },
            },
            backButton: {
                buttonIcon: {
                    style: {
                        minWidth: '16px',
                        minHeight: '16px',
                        fill: PALETTE.BREADCRUMBS_BACK_BUTTON_ICON_COLOR,
                    },
                    src: 'arrow-left',
                },
            },
        },
        QuickNavigationButton: {
            titleLabel: {
                style: {
                    ...PALETTE.BREADCRUMBS_QUICK_NAVIGATION_CATEGORY_TEXT,
                },
            },
            subTitleLabel: {
                style: {
                    ...PALETTE.BREADCRUMBS_QUICK_NAVIGATION_TOURNAMENT_TEXT,
                },
            },
            expandButtonIcon: {
                style: {
                    fill: PALETTE.BREADCRUMBS_QUICK_NAVIGATION_ICON_COLOR,
                },
            },
        },
        // Notification subscriber
        EventNotificationSubscriber: {
            bellIcon: icon(PALETTE.BREADCRUMBS_SUBSCRIBER_BELL_ICON_COLOR),
            dotNotification: generateDotNotification(PALETTE.BREADCRUMBS_SUBSCRIBER_DOT_NOTIFICATION),
            // TODO: rework this to use generateSimplePopover in the future
            notificationPopup: generatePopover(PALETTE.EVENT_NOTIFICATION_SUBSCRIBER_POPOVER),
            subscribeEventsToggle: {
                toggleButton: generateSwitch(PALETTE.EVENT_NOTIFICATION_SUBSCRIBER_SWITCH),
            },
        },
        // It is just popover
        SubscribeEventsOnboarding: {
            closeButton: {
                buttonIcon: icon(PALETTE.EVENT_NOTIFICATION_SUBSCRIBER_POPOVER.POPOVER_CLOSE_ICON_COLOR, 'close'),
            },
            description: {
                style: PALETTE.EVENT_NOTIFICATION_SUBSCRIBER_POPOVER.POPOVER_TEXT,
            },
        },
    };
}
